// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"loadingSpinner_spinnerWrapper__ZQgFJ","hasPadding":"loadingSpinner_hasPadding__FNoRT"};